import React from 'react';
import QuantumSDKDashboard from './components/QuantumSDKDashboard';

function App() {
  return <QuantumSDKDashboard />;
}

export default App;
